// <Hand> — the private hand card (#hand): your secret WORD only. PURE function of `app`, mirroring
// the classic renderHand() string. HIDDEN-ROLE rule (the important one): during the round only
// `me.word` is shown with a 身份保密 secret line — the role is revealed ONLY at settlement
// (phase==='ended' && me.role). Reads the PRIVATE room.me (which carries the word + the role once
// settled); public state never leaks word/role. Emits the SAME .hand-strip markup so the smoke
// grep contract stays green. See PREACT-MIGRATION.md.
import type { VNode } from 'preact';
import { html, t } from '../shared.js';

export function Hand({ app }: { app: AppState }): VNode | VNode[] | '' {
  const r: Room | null = app.room;
  const me: Me | null | undefined = r && r.me;
  if (!me || !me.word) return '';
  const ended: boolean = r!.phase === 'ended' && !!me.role;
  const role: string = ended
    ? (me.role === 'undercover' ? t('hand.youAreUndercover') : t('hand.youAreCivilian'))
    : t('hand.hidden');
  return html`<div class="hand-strip" title=${t('hand.wordTitle')}><span class="hs-label">${t('hand.yourWordLabel')}</span><b class="hs-word">${me.word}</b><span class="hs-role">${role}</span></div>`;
}
